<header class="app-header">
  <div class="app-header__content">
    <div class="app-header__logo-slot app-header__logo-slot--left">
      <img
        class="app-header__logo app-header__logo--tieche"
        src="assets/images/tieche_logo.png"
        alt="Tieche"
      />
    </div>
    <div class="app-header__logo-slot app-header__logo-slot--center">
      <img
        class="app-header__logo app-header__logo--service"
        src="assets/images/fh_logo.png"
        alt="Service Cube"
      />
    </div>
    <div class="app-header__right">
      <button class="app-header__logout" type="button" (click)="logout()">
        Log out
      </button>
    </div>
  </div>

  <app-confirmation-popup
    [title]="confirmationTitle"
    [message]="confirmationMessage"
    [isVisible]="isConfirmationVisible"
    [confirmButtonText]="'Logout'"
    [cancelButtonText]="'Cancel'"
    (onConfirm)="handleConfirmLogout()"
    (onCancel)="handleCancelLogout()"
  ></app-confirmation-popup>
</header>
